import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../authentication/services/authentication.service';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class ErrorInterceptorService implements HttpInterceptor {
    constructor(private readonly authenticationService: AuthenticationService, private readonly oAuthService: OAuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(err => {
                if (err.status === 401) {
                    // In the case of server return 401 due to expired token, the nicer way of handling this is to incur a
                    // refresh. If refresh is successful, then user will have a new token. If refresh
                    // is unsuccessful, the user will be logged out anyway.
                    this.oAuthService.refreshToken();
                }

                return throwError(err);
            })
        );
    }
}
